<template>
  <div>
    <h1>
      <span>Completions</span>
      <span v-if="files && files.length > 0">&#160;({{ files.length }})</span>
    </h1>
    <v-progress-circular indeterminate color="info" v-if="!files" />
    <v-alert :value="files && files.length == 0" type="info"
      >No files found</v-alert
    >
    <template v-if="files && files.length > 0">
      <v-btn @click="download">
        <v-icon>picture_as_pdf</v-icon>&#160;View pdf
      </v-btn>
      <table border="1">
        <tr>
          <th>File</th>
          <th>Category</th>
          <th>Clients</th>
          <th>Subject property</th>
          <th>Bundle</th>
        </tr>
        <tr v-for="file in files" :key="file.id">
          <td>
            <FileGql :file="file" />
          </td>
          <td>
            <span v-if="file.category">{{ file.category.shortname }}</span>
          </td>
          <td>
            <span v-if="file.addressBooksByType">
              <div
                v-for="client in file.addressBooksByType"
                :key="client.entity.id"
              >
                <EntityZ :entity="client.entity" />
              </div>
            </span>
          </td>
          <td>
            <span style="white-space: pre-wrap" v-if="file.subjectProperty">{{
              file.subjectProperty
            }}</span>
          </td>
          <td>
            <input
              type="checkbox"
              v-model="file.bundleCompletionReceived"
              @change="changeBundleCompletionStatus($event, file)"
              v-if="$keycloak.hasRealmRole('billadmin')"
            />
            <span v-if="!$keycloak.hasRealmRole('billadmin')">{{
              file.bundleCompletionReceived
            }}</span>
            <router-link
              :to="{
                name: 'upload',
                query: {
                  objectType: 'file',
                  objectId: file.id,
                  bundleCompletion: true
                }
              }"
              >Upload</router-link
            >
            <br />
            <a
              @click="downloadBundleCompletion(file)"
              v-if="file.bundleCompletion"
            >
              <v-icon>picture_as_pdf</v-icon>&#160;Bundle
            </a>
          </td>
        </tr>
      </table>
    </template>
    <div v-if="statsPanel">
      <p>
        This day in history...shows what stats panel looked like when date
        matched calendar
      </p>
      <StatsPanel :statsPanel="statsPanel" />
    </div>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="1000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import FILES_BY_COMPLETIONDATE from "@/graphql/file/FilesByCompletionDate";
import UPDATE_FILE_BUNDLECOMPLETIONRECEIVED from "@/graphql/file/UpdateFileBundleCompletionReceived";
import UPLOAD_FILE_SIGNED_URL from "@/graphql/document/UploadFileSignedUrl";
import STATS_PANEL from "@/graphql/file/StatsPanel";
import EntityZ from "@/components/link/EntityZ";
import FileGql from "@/components/link/FileGql";
import StatsPanel from "@/components/layout/widgets/StatsPanel";
export default {
  name: "Completions",
  metaInfo() {
    return {
      title: "Completions",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    files: {
      query: FILES_BY_COMPLETIONDATE,
      variables() {
        return {
          date: this.computedDate
        };
      },
      update: (data) => data.filesByCompletionDate,
      fetchPolicy: "cache-and-network"
    },
    statsPanel: {
      query: STATS_PANEL,
      variables() {
        return {
          date: this.computedDate
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: { EntityZ, FileGql, StatsPanel },
  computed: {
    computedDate() {
      return this.$route.query.date
        ? this.$route.query.date.substring(0, 4) +
            "-" +
            this.$route.query.date.substring(4, 6) +
            "-" +
            this.$route.query.date.substring(6, 8)
        : new Date().toISOString().substr(0, 10);
    }
  },
  data() {
    return {
      files: null,
      categories: null,
      clients: null,
      subjectProperties: null,
      statsPanelOld: null,
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    async changeBundleCompletionStatus(e, file) {
      await this.$apollo.mutate({
        mutation: UPDATE_FILE_BUNDLECOMPLETIONRECEIVED,
        variables: {
          id: file.id,
          value: e.target.checked
        },
        refetchQueries: [
          {
            query: FILES_BY_COMPLETIONDATE,
            variables: { date: this.computedDate }
          }
        ]
      });
      this.snackbar = true;
      this.snackbarText = "Bundle completion status changed";
    },
    download() {
      const date = this.$route.query.date;
      const baseurl = `${process.env.VUE_APP_CT_URL}/cors/admin/file/files/completion/diary/pdf`;
      const url = date ? `${baseurl}?date=${date}` : baseurl;
      window.open(url, "_blank");
    },
    async downloadBundleCompletion(file) {
      const response = await this.$apollo.query({
        query: UPLOAD_FILE_SIGNED_URL,
        variables: { id: file.bundleCompletion.id }
      });
      window.open(response.data.uploadFile.upload.signedUrlGet, "_blank");
    }
  }
};
</script>

<style>
</style>
